<div class="container mx-auto px-4 py-8 max-w-7xl">
  <h2 class="text-3xl font-bold text-center text-green-800 mb-8">Latest Blog Posts</h2>
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
    <div *ngFor="let blog of blogs$ | async; let i = index" 
         class="bg-white rounded-lg shadow-md overflow-hidden md:block"
         [class.hidden]="i > 0"
         [class.md:block]="i > 0">
      <div class="aspect-w-16 aspect-h-9 relative">
        <img *ngIf="blog.imageUrl" 
             [src]="blog.imageUrl" 
             [alt]="blog.title"
             class="object-cover w-full h-full">
      </div>
      <div class="p-6">
        <h3 class="text-xl font-semibold text-green-800 mb-2">{{ blog.title }}</h3>
        <p class="text-sm text-gray-600 mb-4">{{ blog.pubDate | date }}</p>
        <div class="prose prose-sm mb-4 text-gray-700" [innerHTML]="blog.description"></div>
        <a [href]="blog.link" 
           target="_blank" 
           class="inline-block font-bold text-green-600 hover:text-green-800 border-b-2 border-green-600">
          Read More
        </a>
      </div>
    </div>
  </div>
</div>
